var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.family)?_c('img',{staticClass:"family-logo",class:_vm.family=== 'tcorp' ? 'pad-tcorp' : '',style:(_vm.getStyle()),attrs:{"src":require('@/assets/content/Logo_' + _vm.family.toUpperCase() + '_150.png')}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }